import ModuleBase from '../shared/ModuleBase';

// style for agency search icons
export default class AgencySearch extends ModuleBase {
    constructor(el) {
        super(el);

        const field = this.$el;
        const input = field.querySelector('input[type="search"]');
        const submitButton = field.querySelector('button[type="submit"]');

        if (!input || !submitButton) return;

        // set wrapper for both icons
        const iconWrapper = document.createElement('div');
        iconWrapper.className = 'ont3-agency-search__icons';
        submitButton.replaceWith(iconWrapper);
        submitButton.classList.add('ont3-agency-search__submit');

        const clearButton = document.createElement('button');
        clearButton.type = 'button';
        clearButton.className = 'ont3-agency-search__clear';
        clearButton.setAttribute('aria-label', 'Suche zurücksetzen');

        iconWrapper.append(clearButton, submitButton);

        const updateState = () => {
            field.classList.toggle('is-filled', input.value.trim().length > 0);
        };

        // init
        updateState();

        input.addEventListener('input', updateState);

        clearButton.addEventListener('click', () => {
            input.value = '';
            updateState();
            input.focus();
        });
    }
}
